import { KK } from '@/define/define'
import { Ref, ref, watch } from 'vue'
import { setData } from './data'

export enum OperateType {
  none,
  light,
  action,
  mgx,
  base,
  advanced,
}

class Operate {
  currentKey: Ref<KK> = ref(-1)
  currentHTMLElement: Ref<HTMLElement | null> = ref(null)
  private actionType = ref(OperateType.none)
  fnCheck = ref(false)
  /** 首次进入功能页后置为 true，设备初始化完成后重置为 false */
  private hasReadSettings = true

  constructor() {
    watch(this.fnCheck, () => {
      this.clear()
    })
  }

  /** 需要触发 readSettings 的功能页类型（排除 mgx 触发设置页） */
  private static readonly SETTINGS_READ_TYPES: ReadonlySet<OperateType> = new Set([OperateType.light, OperateType.action, OperateType.base, OperateType.advanced])

  /** 设备初始化完成后调用，允许功能页触发 readSettings；若已在功能页则立即读取 */
  resetSettingsRead() {
    this.hasReadSettings = false
    // 初始化期间 onMounted 已设置了默认 tab，此时补读一次
    if (Operate.SETTINGS_READ_TYPES.has(this.actionType.value)) {
      this.hasReadSettings = true
      setData.requestSettingsRefresh()
    }
  }

  changeActionType(type: OperateType) {
    this.actionType.value = type
    this.clear()
    // 首次切换到需要读取的功能页时读一次 readSettings，之后不再重复读
    if (Operate.SETTINGS_READ_TYPES.has(type) && !this.hasReadSettings) {
      this.hasReadSettings = true
      setData.requestSettingsRefresh()
    }
  }

  changeCurrentKey(key: KK) {
    this.currentKey.value = key
  }

  getCurrentKey() {
    return this.currentKey.value
  }

  getActionType() {
    return this.actionType
  }

  private clear() {
    this.currentKey.value = -1
  }
}
let operate = new Operate()
export { operate }
